module.exports = __webpack_public_path__ + "static/img/04_img.c5e50f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/sustainability/04_img.jpg
// module id = bfHc
// module chunks = 0